import { tidSelector } from "../util/selectors";
import { TEST_IDS } from "./test-ids";

const { APPLICATION_NAME_FIELD, CREATE_APPLICATION } = TEST_IDS;

export const SELECTORS = {
    APPLICATION_NAME_FIELD: tidSelector(APPLICATION_NAME_FIELD),
    CREATE_APPLICATION: tidSelector(CREATE_APPLICATION),
};
